import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";
import { useLocation, useNavigate } from "react-router-dom";

const links = [
  ["story", "Story"],
  ["acting", "Acting"],
  ["activism", "Activism"],
  ["fashion", "Fashion"],
  ["press", "Press"],
  ["contact", "Contact"],
];

export const Nav = () => {
  const [solid, setSolid] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const on = () => setSolid(window.scrollY > 60);
    window.addEventListener("scroll", on, { passive: true });
    return () => window.removeEventListener("scroll", on);
  }, []);

  const nav = useNavigate();
  const { pathname } = useLocation();
  const go = (p) => {
    setOpen(false);
    nav(p);
  };

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 inset-x-0 z-50 transition-[background-color,backdrop-filter] duration-500 ${
        solid || open ? "bg-[#fbf8f4]/95 backdrop-blur-xl border-b border-black/5" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1500px] mx-auto px-5 sm:px-10 h-20 flex items-center justify-between">
        <button data-testid="nav-logo" onClick={() => go("/")} className="flex items-center gap-3 text-[var(--ink)]">
          <Logo className="w-10 h-10" />
          <span className="font-display text-lg tracking-[0.2em] hidden sm:inline">MIMI TAO</span>
        </button>
        <nav className="hidden lg:flex items-center gap-10">
          {links.map(([id, label]) => (
            <button key={id} data-testid={`nav-link-${id}`} onClick={() => go(`/${id}`)}
              className={`link-line text-[13px] uppercase tracking-[0.22em] transition-colors ${pathname === `/${id}` ? "text-[var(--gold)] bg-[length:100%_1px]" : "text-stone-600 hover:text-[var(--ink)]"}`}>
              {label}
            </button>
          ))}
        </nav>
        <button data-testid="nav-book-btn" onClick={() => go("/contact")}
          className="hidden lg:inline-flex rounded-full bg-[var(--ink)] px-6 py-2.5 text-[12px] uppercase tracking-[0.22em] text-white hover:bg-[var(--gold)] transition-colors duration-500">
          Enquire
        </button>
        <button data-testid="nav-mobile-toggle" onClick={() => setOpen(!open)} className="lg:hidden text-[var(--ink)] p-2" aria-label="Menu">
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
      {open && (
        <div data-testid="nav-mobile-menu" className="lg:hidden px-5 pb-8 pt-2 flex flex-col gap-5 border-t border-black/5">
          {links.map(([id, label]) => (
            <button key={id} data-testid={`nav-mobile-link-${id}`} onClick={() => go(`/${id}`)}
              className={`text-left font-display text-3xl ${pathname === `/${id}` ? "italic text-[var(--gold)]" : "text-[var(--ink)]"}`}>
              {label}
            </button>
          ))}
        </div>
      )}
    </header>
  );
};
